/** @flow */
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import Page from 'common/components/Page';
import DefaultImg from './assets/default_image.png';
import PdfTutorialCard from './components/PdfTutorialCard';
import pdfs from './domain/pdfs';

const SalesContainter = styled.div`
  display: flex;
  flex:1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
`;

const TutorialContainer = styled.div`
    max-width: 980px;
    width: 100%;
`;

const TutorialSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

type Props = {
  t: any,
}

function TutorialPage({ t }: Props) {
  return (
    <Page title={t('tutorialPageTitle')}>
      <SalesContainter>
        <TutorialContainer>
          <TutorialSection>
            <PdfTutorialCard title={t('createCampaign')} pdf={pdfs.folloCreateCampaign} page={1} image={DefaultImg} />
            <PdfTutorialCard title={t('addBroadcastTime')} pdf={pdfs.folloAddBroadcastTime} page={1} image={DefaultImg} />
            <PdfTutorialCard title={t('campaignPerformance')} pdf={pdfs.folloCampaignPerformance} page={1} image={DefaultImg} />
            <PdfTutorialCard title={t('campaignPerformance')} pdf={pdfs.folloCompleteCampaign} page={1} image={DefaultImg} />
          </TutorialSection>
        </TutorialContainer>
      </SalesContainter>
    </Page>
  );
}

export default translate('tutorials')(TutorialPage);



// WEBPACK FOOTER //
// ./src/advertisers/modules/tutorials/TutorialPage.js